// themeSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { ThemeState } from '../types';

//~ Keep a reference to this slice's name for cleanup in case of persistReducer usage
export const name = 'theme';

//~ Initialize your state here
const initialState = 'dark' as ThemeState;

export const themeSlice = createSlice({
    name,
    initialState,
    reducers: {
        //~ Define your synchronous reducers here
        clearTheme: () => {
            return initialState;
        },
        toggleTheme: (state) => {
            return state === 'light' ? 'dark' : 'light';
        },
        setTheme: (_, { payload }) => {
            return payload;
        },
    },
    selectors: {
        //~ Define your selectors here
        //select__PROPERTY_NAME_PASCAL__: (sliceState) => sliceState.__PROPERTY_NAME_CAMEL__,

        selectThemeState: (sliceState) => sliceState,
    },
});

//~ Export defined synchronous reducers here
export const { clearTheme, toggleTheme, setTheme } = themeSlice.actions;

//~ Export defined selectors here
export const { selectThemeState } = themeSlice.selectors;

export const themeReducer = themeSlice.reducer;
export default themeReducer;
